module.exports = __webpack_public_path__ + "static/media/carl746-058.898f0c65.jpg";